import { primaryColor } from '../constants';

const cardStyle = {
  textAlign: 'left',
	padding: "10px",
	borderRadius: "3px",
  fontWeight: '400',
  backgroundColor: '#fff',
  // boxShadow: `5px 5px 5px ${primaryColor}`,
  color: "#282C34",
  border: '2px solid #DADCE0'
}

export function Card({ style, children }){
  return (
    <div style={{ ...cardStyle, ...style }}>
      {children}
    </div>
  );
}